var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgressFrom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "progress-from",
    d: "M23.0387 12C23.0387 17.9508 18.1624 22.7955 12.1216 22.7955C6.08079 22.7955 1.20452 17.9508 1.20452 12C1.20452 6.04925 6.08079 1.20452 12.1216 1.20452C18.1624 1.20452 23.0387 6.04925 23.0387 12Z",
    fill: "url(#paint0_linear_1266_30076)",
    stroke: "url(#paint1_linear_1266_30076)",
    strokeWidth: 2.40905
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1266_30076",
    x1: 12.5013,
    y1: 23.835,
    x2: 12.433,
    y2: -0.164841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AB58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E676"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1266_30076",
    x1: 23.591,
    y1: 24,
    x2: 0.761183,
    y2: 24.0649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AB58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E676"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressFrom);
export default __webpack_public_path__ + "static/media/progress-from.07595bf79a97bd4d4707bba17b90ea93.svg";
export { ForwardRef as ReactComponent };